function normalizeMoney(value) {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : 0;
}

export function buildPaymentSummaryLines(entry) {
  const payment = entry?.orderPayment ?? null;
  const currency = String(payment?.currency ?? 'EUR').toUpperCase();
  const lines = [];
  const fallbackAmount = normalizeMoney(entry?.amountValue);
  const pickAmount = (...candidates) => {
    for (const candidate of candidates) {
      const normalized = normalizeMoney(candidate);
      if (normalized > 0) return normalized;
    }
    return 0;
  };
  const basePriceFromPayment = pickAmount(payment?.price, payment?.amount, payment?.subtotal, payment?.base, fallbackAmount);
  const shipping = normalizeMoney(payment?.shipping);
  const vatAmount = normalizeMoney(payment?.taxes);
  const isLimitedEdition = entry?.type === 'limited_edition';
  const isSuartePlus = entry?.type === 'suarte_plus' || entry?.type === 'subscriptions' || String(entry?.description ?? '').toLowerCase().includes('suarte+');
  const isSupport = entry?.type === 'support';
  const limitedEditionData = entry?.orderLimitedEditionData ?? {};
  const limitedEditionBasePrice = pickAmount(limitedEditionData?.base_price, limitedEditionData?.size_data?.base_price, limitedEditionData?.size_data?.price);
  const basePrice = isLimitedEdition ? (limitedEditionBasePrice > 0 ? limitedEditionBasePrice : basePriceFromPayment) : basePriceFromPayment;
  const total = pickAmount(payment?.total, basePrice + shipping + vatAmount, fallbackAmount);
  const framePrice = normalizeMoney(limitedEditionData?.frame_price ?? limitedEditionData?.size_data?.frame_price);
  const labelPrice = normalizeMoney(limitedEditionData?.museum_label_price ?? limitedEditionData?.size_data?.museum_label_price);
  const addOnTotal = normalizeMoney(limitedEditionData?.add_on_total ?? limitedEditionData?.size_data?.add_on_total);

  if (basePrice > 0) lines.push({ label: isLimitedEdition ? 'Limited edition' : isSuartePlus ? 'Suarte+' : isSupport ? 'Support' : 'Product', amount: basePrice, currency });
  if (isLimitedEdition && framePrice > 0) lines.push({ label: 'Frame', amount: framePrice, currency });
  if (isLimitedEdition && labelPrice > 0) lines.push({ label: 'Museum label', amount: labelPrice, currency });
  if (isLimitedEdition && addOnTotal > 0 && framePrice <= 0 && labelPrice <= 0) lines.push({ label: 'Add-ons', amount: addOnTotal, currency });
  if (shipping > 0) lines.push({ label: 'Shipping', amount: shipping, currency });
  lines.push({ label: 'VAT', amount: vatAmount, currency });
  lines.push({ label: 'Total paid', amount: total, currency, isTotal: true });

  return lines;
}
